<div class="c-notification c-notification--s{{vm.theme || 2}}">
	<div class="o-grid" [ngClass]="{'o-grid--wrap@up-to-md': !vm.narrow, 'o-grid--wrap': vm.narrow}">
		<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--center-v u-no-p" [ngClass]="{'o-grid__cell--w-fit@md-and-up': !vm.narrow}">
			<div class="o-grid">
				<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--flex o-grid__cell--center-v u-no-pr" *ngIf="vm.icon">
					<i class="o-icon o-icon--{{vm.icon}} c-notification__icon" aria-hidden="true"></i>
				</div>
				<div class="o-grid__cell o-grid__cell--flex o-grid__cell--center-v">
					<p class="c-text c-text--bold c-text--wrap c-notification__text" [innerHtml]="vm.content"></p>
				</div>
			</div>
		</div>
		<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--center-v u-no-p" [ngClass]="{'o-grid__cell--w-fixed@md-and-up': !vm.narrow}" *ngIf="vm.btnText && (vm.href || vm.action)">
			<div class="o-grid">
				<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right">
					<a href="{{vm.href}}" target="_blank" class="c-button c-button--link c-notification__button u-no-wrap" [click]="vm.action">{{ vm.btnText }}</a>
				</div>
			</div>
		</div>
	</div>
</div>
